import { makeDataStore } from '../y/data-store';
import { yGetI18N, YI18NString } from '../y/i18n';
import { YCountryId, YFlags, YId, YTaggedId } from '../y/types';

export type CEventSortOrder = 'popular' | 'latest' | 'date';
export type CEventTagFlag = 'create_no_length' | 'create_dropin' | 'show_past' | 'show_future' | 'show_cities' | 'show_all_cities';
export type CEventTagId = YTaggedId<'c_event_tag'>;

export interface CEventTag {
    id: YId;
    is_genre: boolean;
    is_collection: boolean;
    is_hidden: boolean;
    can_select: boolean;
    can_filter: boolean;
    name: YI18NString;
    description: YI18NString;
    slug?: string;
    dynamic?: string;
    sort_order: CEventSortOrder;
    carousel: YCountryId[];
    carousel_image?: YId;
    og_image?: YId;
    flags: YFlags<CEventTagFlag>;
}

export function cEventTagName(tag?: CEventTag) {
    return yGetI18N(tag?.name);
}

declare global {
    interface Window {
        ab_event_tags?: CEventTag[];
    }
}

export const c_event_tags = makeDataStore('new_event_tags', 'event_tag', (m: CEventTag) => m, Object.assign);

if(window.ab_event_tags)
    c_event_tags.init(window.ab_event_tags);

